import classNames from "classnames/bind";
import styles from "./index.module.scss";
import { Card, Form, Input, Button, notification } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import authApi from "api/auth";
import { useNavigate } from 'react-router-dom';
import { setToken, setUser } from "utils";
import { setHeader } from "api/axiosService";
import { useTranslation } from "react-i18next";
import { rolesMoveToNoti } from "./roles";

const cx = classNames.bind(styles);

export default function LoginPage() {
	const navigate = useNavigate();
	const [api, contextHolder] = notification.useNotification();
	const [form] = Form.useForm();

	const { t } = useTranslation()

	const openNotificationWithIcon = (type, message, description) => {
		api[type]({ message, description });
	};

	const onFinish = async (values) => {
		try {
			const { token, user } = await authApi.login(values);
			openNotificationWithIcon('success', t('notification'), t('loginSuccess'))
			setUser(user)
			setToken(token)
			setHeader('Authorization', token)
			navigate(rolesMoveToNoti.includes(+user.role) ? '/admin/notification' : '/admin/timesheet')
		} catch (error) {
			openNotificationWithIcon('error', t('error'), error?.response?.data?.message)
		}
	};

	return (
		<div className={cx("page-login")}>
			{contextHolder}
			<Card className={cx("login-card")} style={{ width: 500 }}>
				<p className={cx("title")}>{t('login')}</p>
				<Form form={form} onFinish={onFinish}>
					<Form.Item
						name="user_name"
						rules={[
							{
								required: true,
							},
						]}
					>
						<Input
							prefix={<UserOutlined className="site-form-item-icon" />}
							placeholder={t('userName')}
							size="large"
						/>
					</Form.Item>
					<Form.Item
						name="password"
						rules={[
							{
								required: true,
							},
						]}
					>
						<Input.Password
							prefix={<LockOutlined className="site-form-item-icon" />}
							placeholder={t('password')}
							size="large"
						/>
					</Form.Item>
					<Button type="primary" htmlType="submit" className={cx("login-form-button")} size="large">
						{t('login')}
					</Button>
				</Form>
			</Card>
		</div>
	);
}
